var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1213_530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 4.5H8V3C8 2.60218 7.84196 2.22064 7.56066 1.93934C7.27936 1.65804 6.89782 1.5 6.5 1.5C6.10218 1.5 5.72064 1.65804 5.43934 1.93934C5.15804 2.22064 5 2.60218 5 3V4.5H3.5V3C3.5 2.20435 3.81607 1.44129 4.37868 0.87868C4.94129 0.316071 5.70435 0 6.5 0C7.29565 0 8.05871 0.316071 8.62132 0.87868C9.18393 1.44129 9.5 2.20435 9.5 3V4.5Z",
    fill: "#4B5565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 5.5H2C1.80109 5.5 1.61032 5.57902 1.46967 5.71967C1.32902 5.86032 1.25 6.05109 1.25 6.25V11.5C1.25 11.6989 1.32902 11.8897 1.46967 12.0303C1.61032 12.171 1.80109 12.25 2 12.25H11C11.1989 12.25 11.3897 12.171 11.5303 12.0303C11.671 11.8897 11.75 11.6989 11.75 11.5V6.25C11.75 6.05109 11.671 5.86032 11.5303 5.71967C11.3897 5.57902 11.1989 5.5 11 5.5ZM6.5 10C6.20333 10 5.91332 9.91203 5.66665 9.7472C5.41997 9.58238 5.22771 9.34811 5.11418 9.07402C5.00065 8.79994 4.97094 8.49834 5.02882 8.20736C5.0867 7.91639 5.22956 7.64912 5.43934 7.43934C5.64912 7.22956 5.91639 7.0867 6.20736 7.02882C6.49834 6.97094 6.79994 7.00065 7.07403 7.11418C7.34811 7.22771 7.58238 7.41997 7.7472 7.66664C7.91203 7.91332 8 8.20333 8 8.5C8 8.89782 7.84196 9.27936 7.56066 9.56066C7.27936 9.84196 6.89782 10 6.5 10Z",
    fill: "#4B5565"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1213_530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.2add628f583298118a7a3bfa6ce0da7a.svg";
export { ForwardRef as ReactComponent };